import { configureStore } from '@reduxjs/toolkit'
import { userSlice } from '../store/session'
import { projectSlice } from '../store/projects'
import { estimateSlice } from '../store/estimate'
import { applicationSlice } from '../store/application'
import { stockroomSlice } from '../store/stockroom'
import { equipmentSlice } from '../store/equipment'
import { inventorySlice } from '../store/inventory'
import { paymentSlice } from '../store/payment'
import { employeeSlice } from '../store/employeе'

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['application/updateOffer'],
      },
    }),
  reducer: {
    user: userSlice.reducer,
    project: projectSlice.reducer,
    estimate: estimateSlice.reducer,
    application: applicationSlice.reducer,
    stockroom: stockroomSlice.reducer,
    equipment: equipmentSlice.reducer,
    inventories: inventorySlice.reducer,
    payments: paymentSlice.reducer,
    employees: employeeSlice.reducer,
  },
})
